import React, { useState } from 'react';
import { motion } from 'framer-motion';

export default function Quote() {
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    // In a real app, handle form submission here (e.g., API call)
    setIsSubmitted(true);
  };

  return (
    <div className="py-16 md:py-24 bg-gray-50 min-h-[80vh]">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="bg-white rounded-2xl shadow-xl overflow-hidden"
        >
          <div className="bg-slate-900 px-8 py-10 text-center">
            <h1 className="text-3xl font-extrabold text-white mb-2">Get A Quote</h1>
            <p className="text-slate-300">Have a question or want to get in touch? Send us a message.</p>
          </div>

          <div className="p-8 md:p-10">
            {isSubmitted ? (
              <div className="text-center py-10">
                <div className="w-16 h-16 bg-green-100 text-green-600 rounded-full flex items-center justify-center mx-auto mb-4 text-2xl">✓</div>
                <h3 className="text-2xl font-bold text-gray-900 mb-2">Message Sent!</h3>
                <p className="text-gray-600">Thank you for reaching out. We will get back to you shortly.</p>
                <button 
                  onClick={() => setIsSubmitted(false)}
                  className="mt-8 text-blue-600 hover:underline font-medium"
                >
                  Send another message
                </button>
              </div>
            ) : (
              <form onSubmit={handleSubmit} className="space-y-6">
                <div className="grid grid-cols-1 gap-6 sm:grid-cols-2">
                  <div>
                    <label htmlFor="firstName" className="block text-sm font-medium text-gray-700">First Name</label>
                    <input type="text" id="firstName" required className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm px-4 py-3 border" />
                  </div>
                  <div>
                    <label htmlFor="lastName" className="block text-sm font-medium text-gray-700">Last Name</label>
                    <input type="text" id="lastName" required className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm px-4 py-3 border" />
                  </div>
                </div>

                <div>
                  <label htmlFor="email" className="block text-sm font-medium text-gray-700">Email Address</label>
                  <input type="email" id="email" required className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm px-4 py-3 border" />
                </div>

                <div>
                  <label htmlFor="phone" className="block text-sm font-medium text-gray-700">Phone Number</label>
                  <input type="tel" id="phone" required className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm px-4 py-3 border" />
                </div>

                <div>
                  <label htmlFor="message" className="block text-sm font-medium text-gray-700">How can we help you?</label>
                  <textarea id="message" rows={4} required className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm px-4 py-3 border"></textarea>
                </div>

                {/* A2P 10DLC Compliance Checkbox */}
                <div className="flex items-start bg-gray-50 p-4 rounded-lg border border-gray-200">
                  <div className="flex h-5 items-center">
                    <input
                      id="sms-consent"
                      name="sms-consent"
                      type="checkbox"
                      required
                      className="h-4 w-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                    />
                  </div>
                  <div className="ml-3 text-sm">
                    <label htmlFor="sms-consent" className="font-medium text-gray-900">
                      SMS Communications Consent
                    </label>
                    <p className="text-gray-500 mt-1 text-xs leading-relaxed">
                      By checking this box, you agree to receive text messages from World Class Ventures LLC regarding your inquiry, customer support, and marketing. Message frequency varies. Message and data rates may apply. Reply STOP to opt out. Your information will never be shared or sold to third parties for marketing purposes. See our <a href="/#/privacy" className="text-blue-600 hover:underline" target="_blank">Privacy Policy</a> and <a href="/#/terms" className="text-blue-600 hover:underline" target="_blank">Terms of Service</a> for more details.
                    </p>
                  </div>
                </div>

                <div>
                  <button
                    type="submit"
                    className="w-full flex justify-center py-3 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors"
                  >
                    Send Message
                  </button>
                </div>
              </form>
            )}
          </div>
        </motion.div>
      </div>
    </div>
  );
}